import { AnyAction } from 'redux';
import { SET_TAKEN_IDENTIFIERS } from 'src/redux/actions/ticketActions';

export interface TicketsState {
  takenIdentifiers: string[];
}

const DEFAULT: TicketsState = {
  takenIdentifiers: [],
};

const TicketsReducer = (state = DEFAULT, action: AnyAction): TicketsState => {
  switch (action.type) {
    case SET_TAKEN_IDENTIFIERS:
      return {
        ...state,
        takenIdentifiers: action.payload as string[],
      };
    default:
      return state;
  }
};

export default TicketsReducer;
